export default "__VITE_ASSET__CJpFavwY__"